import { DataManager } from '@syncfusion/ej2-data';
import { DatePipe, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommandClickEventArgs, GridModule, RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { TitleBarComponent } from 'src/app/base/shared/title-bar/title-bar.component';
import { ParkingCardService } from './parking-card.service';
import { ClientService } from 'src/app/base/services/client/client.service';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { FormsModule } from '@angular/forms';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { ModalService } from 'src/app/base/shared/modal/modal.service';

@Component({
    selector: 'app-parking-card',
    templateUrl: './parking-card.component.html',
    styleUrls: ['./parking-card.component.scss'],
    imports: [
        TitleBarComponent,
        GridModule,
        NgIf,
        TranslateModule,
        DatePipe,
        FormsModule
    ]
})

export class ParkingCardComponent extends GridBaseComponent implements OnInit {

  public get issuedToMe(): boolean {
    return this.parkingCardService.issuedToMe;
  }

  public set issuedToMe(value: boolean) {
    this.parkingCardService.issuedToMe = value;
  }

  constructor(
    clientService: ClientService,
    translate: TranslateService,
    private spinnerService: SpinnerService,
    private parkingCardService: ParkingCardService,
    private modalService: ModalService
  ) {
    super(clientService, translate, parkingCardService);
    this.gridCommands = [{
      type: SfCommandButtonType.None,
      buttonOption:
      {
        cssClass: 'icon-btn',
        iconCss: 'icon-tag--none e-icons e-danger',
      }
    }]
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.parkingCardService, this.spinnerService),
    });
  }

  public rowDataBound(args: RowDataBoundEventArgs): void {
    if (args.data) {
      // show the icon only if the card is active
      var button = args.row.getElementsByClassName('icon-tag--none');
      if (button && button.length > 0 && button[0].parentElement) {
        button[0].parentElement.title = this.translateService.instant('i18n.domain.parking-card.grid.revoke');
        if (!args.data['isActive']) {
          button[0].parentElement.hidden = true;
        }
      }
    }
  }

  public changeView(): void {
    this.grid.refresh();
  }

  public commandClick(args: CommandClickEventArgs) {
    if (args.commandColumn?.type === SfCommandButtonType.None) {
      const id = ((args.rowData) as any).id;
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.parking-card.messages.revoke-title', 'i18n.domain.parking-card.messages.revoke-question');
      dialog.onOkSubject.subscribe(() => {
        this.parkingCardService.revokeParkingCard(id).subscribe(() => {
          this.grid.refresh();
        });
      });
    }
  }

  protected override initializeEditForm(_data: any): void {
    throw new Error('Method not implemented.');
  }

  protected override getEditDialogTitleParams(_rowData: any) {
    throw new Error('Method not implemented.');
  }
}
